import {ApolloClient} from "@apollo/client";

import {AssistantMessageFragment, AssistantMessageFragmentDoc} from "../../../../types/generated";
import {SocketMessage} from "../../types";

type UpdateMessageInCacheProps = {
    client: ApolloClient<unknown>;
    socketMessage: SocketMessage;
};

export function updateMessageInCache({client, socketMessage}: UpdateMessageInCacheProps) {
    client.cache.updateFragment<AssistantMessageFragment, null>(
        {
            fragment: AssistantMessageFragmentDoc,
            id: "AssistantConversationMessage:" + socketMessage.id,
        },
        (data) => {
            const metadata = !socketMessage.metadata
                ? null
                : {
                      ambassadorProfile: socketMessage.metadata.ambassadorProfile ?? null,
                      staffProfile: socketMessage.metadata.staffProfile ?? null,
                  };
            if (!data || socketMessage.message.length <= data.message.length) return;
            return {
                ...data,
                message: socketMessage.message,
                metadata,
            };
        },
    );
}
